export default "__VITE_ASSET__bdef4f85__"